import * as React from 'react'
import { FC, useCallback, useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import { useSelector, useDispatch } from 'react-redux'
import { SettingsPage, SideDrawer } from '@sales-center/components'
import { selectAllSalesFunnels } from '@user/store/salesFunnel/slice'
import { SalesFunnelList } from './SalesFunnelList'
import { updateLoadingState } from '@sales-center/common'
import { AddSalesFunnelForm } from './AddSalesFunnelForm'
import { useGetSalesFunnelListOnMount } from '@user/store/salesFunnel/hooks'

export const SalesFunnels: FC = () => {
  const dispatch = useDispatch()
  const loadingStatus = useGetSalesFunnelListOnMount(true)
  const salesFunnels = useSelector(selectAllSalesFunnels)

  const [open, setOpen] = useState(false)
  const hideForm = useCallback(() => setOpen(false), [])

  const openAddForm = useCallback(() => {
    setEditId(undefined)
    setOpen(true)
  }, [])

  const [editId, setEditId] = useState<string>()
  const openEditForm = useCallback((id?: string) => {
    setEditId(id)
    setOpen(true)
  }, [])

  useEffect(() => {
    dispatch(
      updateLoadingState(loadingStatus == 'pending' ? 'visible' : 'hidden'),
    )
  }, [dispatch, loadingStatus])

  return (
    <SettingsPage title="Sales Funnels">
      <Button
        color="primary"
        variant="contained"
        onClick={openAddForm}
        data-test-id="addSalesFunnelBtn"
      >
        Add Sales Funnel
      </Button>

      <SideDrawer
        title={`${!!editId ? 'Edit' : 'Add'} Sales Funnel`}
        open={open}
        onClose={hideForm}
      >
        <AddSalesFunnelForm onClose={hideForm} editId={editId} />
      </SideDrawer>

      <SalesFunnelList salesFunnels={salesFunnels} setEditId={openEditForm} />
    </SettingsPage>
  )
}
